<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :show-close="false"
    custom-class="xpDialogbox">
    <div class="xpDialog" ref="imageTofile">
      <div class="title" slot="title">
        <i class="iconfont icon-xiazai" @click="toImage"></i>
        <i class="iconfont icon-guanbi3" @click="handleClose"></i>
      </div>
      <div class="org-name">{{detail.org_name}}</div>
      <div class="org-time">{{detail.star_name}}星级评定结果反馈</div>
      <div class="xpbox">
        <div class="xp-content">
          <div class="xp-title">
            <img src="@/assets/images/xingjipingdingjieguotit.png" alt="">
          </div>
          <div class="xp-flex">
            <div class="xp-num">
              <div class="xp-fentex">总分</div>
              <div class="xp-fennum">{{detail.score}}</div>
              <div class="line"></div>
              <div class="xp-fentex">星级</div>
              <div class="xingj-box">
                <el-rate
                  v-model="detail.star"
                  disabled
                  text-color="#ff9900"
                  score-template="{value}">
                </el-rate>
              </div>
            </div>
            <div class="xp-chart">
              <div id="chart"></div>
            </div>
          </div>
          <div class="xp-title">
            <img src="@/assets/images/jiafendefenqingkuang.png" alt="">
          </div>
          <div class="xp-defen">
            <div class="defen-item" v-for="item in score_percent" :key="item.name">
              <div class="defen-label">{{item.name}}</div>
              <div class="defen-value">
                <el-progress :percentage="item.percent" status="warning" :stroke-width="10" :show-text="false"></el-progress>
              </div>
              <div class="defen-num">{{item.percent}}%</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </el-dialog>
</template>
<script>
import * as echarts from 'echarts';
import html2canvas from 'html2canvas'
import {getEvaluateOrgReport} from "@/api/admin";

export default {
  name: "evaluateDialog",
  data() {
    return {
      option: {
        title: {
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          left: 'center',
        },
        radar:
          {
            indicator: [
              // { text: '运营能力', max: 100 },
              // { text: '合规经营', max: 100 },
              // { text: '风险防控', max: 100 },
              // { text: '加分项', max: 100 }
            ],
            // indicator: (function (e) {
            //   console.log(e)
            //   var res = [];
            //   var list = ['运营能力', '合规经营', '风险防控', '加分项 ']
            //   for (var i = 0; i <list.length; i++) {
            //     res.push({ text: list[i] + '%', max: 100 });
            //   }
            //   return res;
            // })(),
            center: ['48%', '48%'],
            radius: 80
          }
        ,
        series:
          [
          {
            type: 'radar',
            areaStyle: {},
            data: [
              // {
              //   value: [60, 73, 85, 40],
              // }
            ]
          }
        ]
      },
      detail:{
        org_name:'',
        star_name:'',
        score: 0,
        star: 0,
      },
      score_percent: []
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String,Number],
      default: ''
    },
      oid: {
      type: [String,Number],
      default: ''
    },
  },

  components: {},
  created() {

  },
  mounted() {

  },
  methods: {

    async init(){
      let _data = await getEvaluateOrgReport(this.oid,this.id);
      if(_data.status == 200){
        this.detail = {
          org_name: _data.data.org_name,
          star_name:_data.data.star_name,
          score: _data.data.score,
          star: _data.data.star,
        }
        this.score_percent = _data.data.score_percent
        let ary = []
        let nums = []
        this.score_percent.map(item => {
         ary.push({
            text: item.name,
            max: item.score
          })
          nums.push(item.getScore)
        })
        this.option.radar.indicator = ary
        this.option.series[0].data.push({
          value: nums,
        })
        echarts.init(document.getElementById('chart')).setOption(this.option)
      }
    },

    toImage () {
      // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
      html2canvas(this.$refs.imageTofile, {
        backgroundColor: null,
        useCORS: true // 解决文件跨域问题
      }).then((canvas) => {
        let url = canvas.toDataURL('image/png');
        if(url){
          this.frontDownload(url)
        }
      })
    },

    frontDownload(url){
      var a =  document. createElement('a') //創建一个<a></a>金
      a.href = url
      a.download = '附件' //设置下载文件文件名
      a.target = '_blank'
      a.style.display ='none' //a
      document.body.appendChild(a) //将a标签追加到文档对象中
      a.click() //模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove() //一次性的，用完就删除a标签
    },

    handleClose(){
      this.$emit('handleClose',false)
    },
  },
  watch: {
    dialogVisible(){
      if(this.dialogVisible) {
        this.init()
      }
    }
  },
  filters: {}
}
</script>

<style scoped lang="scss">
/deep/ {
  .xpDialog .el-dialog__body {
    padding: 0 18px;
  }
  .el-icon {
    color: #ffffff;
  }
  .el-icon:hover {
    color: #ffffff;
  }
  .xpDialogbox {
    width: max-content;
    padding: 0;
    background: none;
  }
  .xpDialog {
    width: 688px;
    min-height: 700px;
    background-image: linear-gradient(180deg,
      #2791ff 0%,
      #7eb6ff 100%);
    border-radius: 10px;
    padding: 20px;
  }
  .el-rate__icon {
    font-size: 24px;
  }
}

.title {
  width: 100%;
  text-align: right;
  i {
    font-size: 18px;
    color: #ffffff;
    cursor: pointer;
    &.icon-xiazai {
      font-size: 23px;
      margin-right: 20px;
    }
  }
}

.org-time {
  width: 100%;
  text-align: center;
  font-size: 26px;
  color: #ffffff;
  font-weight: bold;
  margin-top: 5px;
}

.org-name {
  width: 100%;
  text-align: center;
  font-size: 20px;
  color: #ffffff;
  font-weight: bold;
}

.xpbox {
  width: 100%;
  background-color: rgba(255,255,255,0.35);
  padding: 6px;
  border-radius: 10px;
  margin-top: 20px;
  .xp-content {
    width: 100%;
    padding: 25px;
    background: #ffffff;
    border-radius: 10px;
    .xp-defen {
      width: 100%;
      padding-top: 20px;
      .defen-item {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 20px;
        .defen-label {
          width: 80px;
          font-size: 14px;
          color: #999999;
          font-weight: bold;
        }
        .defen-num {
          width: 60px;
          font-size: 14px;
          color: #999999;
          font-weight: bold;
          text-align: right;
        }
        .defen-value {
          flex: 1;

        }
      }
    }
    .xp-flex {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 20px 0;
      .xp-chart {
        width: 348px;
        height: 230px;
        background-color: #f7faff;
        border-radius: 10px;
        padding: 10px;
        #chart {
          width: 348px;
          height: 230px;
        }
      }
      .xp-num {
        width: 184px;
        height: 230px;
        background-image: linear-gradient(185deg,
          #2791ff 0%,
          #81b6ff 100%);
        border-radius: 10px;
        padding: 14px;
        .xingj-box {
          width: 100%;
          display: flex;
          justify-content: center;
          padding-top: 15px;
        }
        .line {
          width: 100%;
          height: 1px;
          background: #ffffff;
          margin-bottom: 15px;
        }
        .xp-fennum {
          width: 100%;
          text-align: center;
          font-size: 48px;
          color: #ffffff;
          font-weight: bold;
        }
        .xp-fentex {
          width: 100%;
          text-align: center;
          font-size: 22px;
          color: #ffffff;
        }
      }
    }
    .xp-title {
      width: 100%;
    }
  }
}


</style>


